import axios from 'axios'

const namespaced = true

const state = {
  packages: null,
  visible: false,
  portals: null,
  statuses: null,
  definitePackage: null,
  documents: null,
  loading: false,
  pages: null,
  pids: null,
  declineReasons: null,
  packagePid: null,
  packageChainid: null,
  packageStatus: null,
  package: null,
}
const actions = {
  getEcrPackages({ commit }, data) {
    const params = new URLSearchParams(data.queryParams)
    let keysForDel = [];
    params.forEach((value, key) => {
      if (value === '') {
        keysForDel.push(key)
      }
    })
    keysForDel.forEach(key => {
      params.delete(key)
    })
    const url = `/api/private/v5.0/ecr/${data.portalId}/packages/?`
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: url + params.toString()
      })
        .then(response => {
          commit('setPackages', response.data)
          commit('setVisible', false)
          resolve()
        })
        .catch(error => {
          commit('setVisible', false)
          reject(error)
        })
    })
  },
  createEcr ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/api/private/v5.0/ecr/',
        data
      })
        .then(response => {
          commit('setPackagePid', response.data.pid)
          resolve({ did: response.data.document.did })
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  editEcr (_, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'PUT',
        url: '/api/private/v5.0/ecr/',
        data
      })
      .then(() => {
        resolve()
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  getEcrByPid ({ commit }, data) {
    commit('setPackage', null)
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v5.0/ecr/${data.pid}/`
      })
        .then(response => {
          commit('setPackage', { data: response.data, new: data.new })
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getPackageDocumentsList ({ commit }, data) {
    commit('setPackageDocumentsList', null)
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v5.0/packages/${data}/`
      })
      .then(response => {
        commit('setPackageDocumentsList', response.data.documents)
        commit('setPackagePid', response.data.pid)
        commit('setPackageChainid', response.data.chainid)
        commit('setPackageStatus', response.data.status)
        resolve()
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  sendPackageFts (_, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `/api/private/v5.0/packages/send/${data}/`
      })
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadPackageDocuments ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v5.0/portals/${data.portalId}/packages/${data.package}/documents/`
      })
        .then(response => {
          commit('setPackageDocuments', response.data)
          commit('setVisible', false)
          resolve()
        })
        .catch(error => {
          commit('setVisible', false)
          reject(error)
        })
    })
  }
}
const mutations = {
  setPackages(state, data) {
    for (let i = 0; i < data.packages.length; i++) {
      data.packages[i].documents = null
      data.packages[i].actions = { visible: false }
      data.packages[i].index = i.toString()
      data.packages[i].waybill = data.packages[i].info[1]
      data.packages[i].vehicle = data.packages[i].info[4]
      data.packages[i].manifest = { id: null, progress: false }
    }
    state.packages = data.packages.filter((p) => {
      return p.status !== 107
    })
    if (data.pages) {
      state.pages = data.pages
    }
    if (data.pids) {
      state.pids = data.pids
    }
  },
  setVisible(state, value) {
    state.visible = value
  },
  setPackagePid (state, value) {
    state.packagePid = value
  },
  setPackageChainid (state, value) {
    state.packageChainid = value
  },
  setPackageStatus (state, value) {
    state.packageStatus = value
  },
  setPackage (state, value) {
    const isNewPackageInChain = [4, 731].find((item) => {
      return item === parseInt(state.packageStatus)
    })
    if (value) {
      if ((!!isNewPackageInChain === true) || value.new) {
        if (value.data) value.data.did = null
      }
      state.package = value.data
    }
  },
  setPackageDocumentsList (state, value) {
    state.packageDocumentsList = value
  },
  setPackageDocuments (state, data) {
    state.documents = data
  },
}
const getters = {
}

export default {
  namespaced,
  state,
  actions,
  mutations,
  getters
}
